import { gl } from '../../Engine';
import { Environment } from '../../data/Environment';
import { DoseDistribution } from '../../data/dose/DoseDistribution';
import { TextureView } from '../TextureView';
import { Layer } from './Layer';
import { LayerBit } from './LayerBit';
import { DoseFilter, FilterClass } from './filters/Filter';

/**
 * {@link DoseLayer} provides common properties of {@link Layer Layers} for {@link DoseObject Dose}data.\
 * {@link DoseLayer DoseLayers} have {@link internalFormat} of type {@link gl.RGBA8} and\
 * {@link format} of type {@link gl.RGBA}.
 */
export class DoseLayer extends Layer<DoseDistribution> {
    /**
     * {@link DoseLayer} constructor which constructs a new {@link DoseLayer} with the {@link getDefaultFilter default dose filter}.
     * @param parent {@link TextureView} on which this {@link DoseLayer} resides.
     */
    public constructor(parent: TextureView, env: Environment) {
        super(parent, env);
    }

    /**
     * Method to get the default {@link FilterClass} used by {@link DoseLayer DoseLayers}.
     * @returns The {@link DoseFilter}, which renders the {@link DoseDistribution dose data} without any {@link DoseFilter.postProcessing postProcessing effects}.
     */
    public getDefaultFilter(): FilterClass<DoseDistribution> {
        return DoseFilter;
    }

    /**
     * The internal format of {@link DoseLayer}s' {@link Layer._texture texture}.\
     * {@link DoseLayer DoseLayers} use this format to support colors.
     */
    public get internalFormat(): number {
        return gl.RGBA8;
    }

    /**
     * The format of the {@link Layer._texture texture} this {@link DoseLayer} defines.
     */
    public get format(): number {
        return gl.RGBA;
    }

    /**
     * The {@link LayerBit.DOSE_LAYER_BIT}
     */
    public get layerBit(): number {
        return LayerBit.DOSE_LAYER_BIT;
    }

    /**
     * Method to retrieve the {@link DoseDistribution DoseDistributions} currently loaded in the {@link Environment}.
     * @param environment The {@link Environment} from which the {@link DoseDistribution DoseDistributions} are loaded.
     * @returns An {@link Array} of all the {@link DoseDistribution DoseDistributions} currently loaded in the {@link environment}.
     */
    public getTargets(environment: Environment): DoseDistribution[] {
        if (environment.dose) {
            return [environment.dose];
        }
        return [];
    }
}
